import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/element.scss'
import './assets/css/variable.scss'
import '@/assets/css/common.less'
import store from './vuex'
import Vuex from 'vuex'
import {router} from './router'
import 'font-awesome/css/font-awesome.min.css'
import {v4 as uuidv4} from 'uuid'
import './common/axiosSetting'
import '@/components/svgIcon/index';
// import horizontalScroll from 'el-table-horizontal-scroll'
import globalData from "@/common/js/globalData";
import dict from "@/common/js/dict";
import menu from "@/common/menu";
import {barOptionTypeMap} from "@/components/table/model/barOption";

import UmyUi from 'umy-ui';

import zlVue from "@zhilian/zl-vue"
import {rootUrl,onlinePreviewUrl} from "@/config"

Vue.prototype.uuid = function () {
    return uuidv4();
}

Vue.prototype.globalData = globalData;
Vue.prototype.dict = dict.dict;
Vue.prototype.op = menu.op;
Vue.prototype.pageOpt = menu.pageOpt;

Vue.prototype.batchProcess = function ({taskList, saveMethod, onSuccess, onFailed, width = '500px', autoClosed = true,count}) {
    let box;
    let finalSuccess;
    if (!onSuccess) {
        onSuccess = () => {
            // 如果批量处理全部处理成功，关闭弹窗
            // box.visible = false;
        }
    }
    if(autoClosed){
        finalSuccess = () =>{
            onSuccess()
            box.visible = false
        }
    }
    if (!onFailed) {
        onFailed = () => {
        };
    }
    let on = {success: finalSuccess,failed:onFailed};
    let slot = this.$createElement('batch-process', {
        on,
        attrs:{
            saveMethod,
            count,
            task: taskList
        }
    });
    box = this.$dlgbox({width,slot});

    return box;
}

let fieldCtlFunc = function (el, binding, vNode) {let fieldCtl = vNode.context.fieldCtl
    return;
    if(fieldCtl.__all__){
        console.log('fieldCtl __all__')
        return;
    }
    if(binding.value === binding.oldValue){
        console.log('fieldCtl __equals__')
        return;
    }
    console.log('fieldCtl',{level:binding.value,binding})
    el.classList.add('fieldCtl-' + (binding.value||0));
    switch (binding.value) {
        case 0:// 不可见
            console.red("fieldCtl 不可见",{el,binding});
            return
        case 1:// 只读
            let formWrapper = el.querySelector(".el-form-item__content div.el-input")
            formWrapper.classList.add("is-disabled");
            let formEl = formWrapper.children[0];
            formEl.disabled = 'disabled';
            console.red("fieldCtl disabled",{el,binding});
            return
        case 2:// 可编辑
            console.red("fieldCtl edit",{el,binding});
            return
    }
}
Vue.directive('field-ctl', {
    update: fieldCtlFunc,
    bind: fieldCtlFunc,
});

Vue.use(UmyUi);
Vue.use(ElementUI)
Vue.use(Vuex)
// Vue.use(horizontalScroll)
zlVue.initConfig({
    rootUrl,
    onlinePreviewUrl,
    objEdit: () => import("@/common/objFieldEdit")
});
Object.assign(zlVue.barOptionTypeMap, barOptionTypeMap);
Vue.use(zlVue.install);

Vue.prototype.rootObj = ()=> {
    return {
        id: '',
        fieldCtl: new Proxy({},{
            get (a,b,c){
                return 2;
            }
        })
    }
}





window.log = message => console.log(message)

console.red = console.log.bind(console, '%c %s', 'color: red');
console.blue = console.log.bind(console, '%c %s', 'color: blue');
console.yellow = console.log.bind(console, '%c %s', 'color: yellow');
console.green = console.log.bind(console, '%c %s', 'color: green');

import downLoadFile from "@/components/upload/downLoadFile";
import regionSelect from "@/components/regionSelect/inner";

dict.loadDict().then(() => {
    let $toolRoot = new Vue({
        el:         "#toolLayer",
        template:   `<div>
                        <regionSelect ref="regionSelect"/>
                        <ColBatchEdit ref="refColBatchEdit"/>
                        <down-load-file ref="downLoadFile"></down-load-file>
                    </div>`,
        components: {regionSelect,downLoadFile},
    });
    let $app = new Vue({
        el: '#app',
        template: '<App/>',
        router,
        store,
        components: {App},
    });
    $app.downloadFile = (title,id)=>{
        $toolRoot.$refs.downLoadFile.show();
        $toolRoot.$refs.downLoadFile.innerTitle = title;
        $toolRoot.$refs.downLoadFile.selectByFileId(id);
    }
    $app.$toolRoot = $toolRoot;
});




// WEBPACK FOOTER //
// ./src/main.js